import { Container, ColorfulProgress } from '@maas-components/core'
import { StyledBox } from './styles'

function PageLoading() {
  return (
    <Container maxWidth="lg">
      <StyledBox display="flex" justifyContent="center" alignItems="center">
        <ColorfulProgress size={38} />
      </StyledBox>
    </Container>
  )
}

export default PageLoading
